export default "__VITE_ASSET__23973a9e__"